import { useMemo, useState } from "react";
import { ChevronsUpDown, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

const norm = (s) => String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export const SearchPick = ({ items, value, onChange, placeholder, testid, label, search, error }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const current = items.find((it) => it.key === value);
  const results = useMemo(() => {
    const n = norm(q).trim();
    if (!n) return items.slice(0, 60);
    const exact = items.filter((it) => norm(it.key) === n);
    const rest = items.filter((it) => norm(it.key) !== n && norm(search(it)).includes(n));
    return [...exact, ...rest].slice(0, 60);
  }, [q, items, search]);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={`flex h-10 w-full items-center justify-between gap-2 rounded-md border bg-white px-3 text-left text-sm ${error ? "border-rose-400" : "border-input"}`}>
          <span className={`truncate ${current ? "text-slate-900" : "text-slate-400"}`}>{current ? label(current) : value || placeholder}</span>
          {value
            ? <X size={15} className="shrink-0 text-slate-400 hover:text-slate-700" data-testid={`${testid}-clear`} onClick={(e) => { e.stopPropagation(); onChange(""); }} />
            : <ChevronsUpDown size={15} className="shrink-0 text-slate-400" />}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[min(92vw,380px)] p-0" align="start">
        <Command shouldFilter={false}>
          <CommandInput placeholder="Escribe para buscar…" value={q} onValueChange={setQ} data-testid={`${testid}-search`} />
          <CommandList className="max-h-72">
            <CommandEmpty>Sin resultados</CommandEmpty>
            {results.map((it) => (
              <CommandItem key={it.key} value={it.key} onSelect={() => { onChange(it.key); setOpen(false); setQ(""); }} data-testid={`${testid}-option-${it.key}`}>
                {it.node || label(it)}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
